import { getQueryParams, httpApi } from '@api/FW/http.api';
import {
	eDiloCreateResultAdapter,
	eDiloFinanceResultAdapter,
	eDiloLimitsAdapter,
} from '@FW/features/eDilo/api/eDilo.adapters';
import {
	EDiloCreateBodyDTO,
	EDiloCreateResultDTO,
	EDiloFinanceBodyDTO,
	EDiloFinanceResultDTO,
	EDiloLimitsDTO,
} from '@FW/features/eDilo/api/eDilo.dto.types';
import {
	IEDiloCreatePayload,
	IEDiloCreateResult,
	IEDiloFinanceResult,
	IEDiloLimits,
} from '@FW/features/eDilo/api/eDilo.types';

export const getEDiloLimits = (counterparty: string): Promise<IEDiloLimits> =>
	httpApi
		.get<EDiloLimitsDTO>(`eDilo/GetLimits/${counterparty}/`, { params: getQueryParams() })
		.then(({ data }) => eDiloLimitsAdapter(data))
		.catch((err) => {
			throw err;
		});

export const submitEDilo = (
	counterparty: string,
	payload: IEDiloCreatePayload,
): Promise<IEDiloCreateResult> => {
	const body: EDiloCreateBodyDTO = {
		ДоговорУИД: payload.contract,
		СчетУИД: payload.wallet,
		Сумма: payload.amount,
		...(payload.card ? { КартаУИД: payload.card } : {}),
	};
	return httpApi
		.post<EDiloCreateResultDTO>(`eDilo/Create/${counterparty}/`, body, {
			params: getQueryParams(),
		})
		.then(({ data }) => eDiloCreateResultAdapter(data))
		.catch((err) => {
			throw err;
		});
};

export const financeByEDilo = (
	counterparty: string,
	invoiceId: string,
): Promise<IEDiloFinanceResult> => {
	const body: EDiloFinanceBodyDTO = { СчетНаОплатуУИД: invoiceId };
	return httpApi
		.post<EDiloFinanceResultDTO>(`eDilo/FinanceByeDilo/${counterparty}/`, body, {
			params: getQueryParams(),
		})
		.then(({ data }) => eDiloFinanceResultAdapter(data))
		.catch((err) => {
			throw err;
		});
};
